import React from "react";
import { ContentPage } from "@/components/ContentPage";

const sections = [
  {
    id: "collect",
    heading: "Information we collect",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>Account information — name, email, mobile number and password.</li>
        <li>Verification documents — driving licence and government ID at pickup.</li>
        <li>Booking information — pickup city, plan, dates and delivery address.</li>
        <li>Payment information — processed securely by our payment partners; card details never touch our servers.</li>
        <li>Device & usage data — app interactions, IP address, device model to keep the service secure.</li>
      </ul>
    ),
  },
  {
    id: "use",
    heading: "How we use your data",
    body: (
      <p>
        We use your data to operate the service — confirm bookings, deliver
        vehicles, verify identity, process payments, keep you safe on the road
        and improve the product. We may send transactional messages by email,
        SMS and WhatsApp so you never miss a booking update.
      </p>
    ),
  },
  {
    id: "sharing",
    heading: "Sharing",
    body: (
      <p>
        We share the minimum required data with our delivery partners,
        insurance underwriters, payment gateways and analytics providers. We
        never sell personal data. In case of an accident or investigation, we
        may share information with law-enforcement or insurance authorities as
        legally required.
      </p>
    ),
  },
  {
    id: "retention",
    heading: "Retention",
    body: (
      <p>
        We retain personal data for as long as your account is active and for
        the period required by applicable law and tax regulations after that.
      </p>
    ),
  },
  {
    id: "rights",
    heading: "Your rights",
    body: (
      <p>
        You can request access, correction or deletion of your personal data
        by writing to info@theebg.com. We respond within 30 days.
      </p>
    ),
  },
];

const Privacy = () => (
  <ContentPage
    testId="privacy-page"
    eyebrow="Privacy Policy"
    title="Your data. Handled with care."
    subtitle="This policy explains what we collect, how we use it and the controls you have."
    sections={sections}
  />
);

export default Privacy;
